<template>
  <div class="">
    <form
      class="add-form"
      ref="profile_form"
      @submit.prevent="handleSubmit"
      @keydown.enter.prevent="() => {}"
    >
      <div class="form-wrapper full">
        <!-- Organization -->
        <base-input
          :label="`${$t('COMMON.ORGANIZATION')} (*)`"
          :placeholder="$t('COMMON.ORGANIZATION')"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)"
        >
          <organization-selector
            :organization="property.organization.id"
            :filterable="true"
            :showAll="false"
            @organizationChanged="
              (organizationId, organization) => {
                property.organization.id = organizationId;
                property.allowedLocations = [];
                onFormChanged();
              }
            "
            :disabled="!!property.id"
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.organization" />
      </div>

      <div class="form-wrapper full">
        <base-input
          :label="`${$t('COMMON.LOCATION')}`"
          :placeholder="$t('COMMON.LOCATION')"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOCATIONS)"
        >
          <locations-selector
            :locations="property.allowedLocations"
            :filterable="true"
            :showAll="false"
            :multiple="true"
            :organization="property.organization.id"
            @locationsChanged="
              (locations) => {
                property.allowedLocations = locations;
                onFormChanged();
              }
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.allowedLocations" />
      </div>

      <div class="form-wrapper full">
        <base-input
          :label="`${$t('COMMON.OWNERS')}`"
          :placeholder="$t('COMMON.OWNERS')"
          v-if="$currentUserCan($permissions.PERM_VIEW_ANY_CONTACTS)"
        >
          <contacts-selector
            :placeholder="$t('COMMON.OWNERS')"
            :contacts="property.owners"
            :filterable="true"
            :showAll="false"
            :multiple="true"
            :filterOrganization="property.organization.id"
            @contactsChanged="
              (contacts) => {
                property.owners = contacts;
                onFormChanged();
              }
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.owners" />
      </div>

      <div class="form-wrapper full">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.DESIGNATION')} (*)`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.DESIGNATION')"
        >
          <ul class="tabs-lang">
            <li :class="{ active: activeDesignationTab === 'fr' }" @click="activeDesignationTab = 'fr'">Fr</li>
            <li :class="{ active: activeDesignationTab === 'en' }" @click="activeDesignationTab = 'en'">En</li>
          </ul>

          <div v-if="activeDesignationTab === 'fr'">
            <textarea v-model="property.designation_translate.fr" class="form-control" rows="3" :placeholder="$t('PROPERTIES_COLLECTIONS.DESIGNATION')" @change="onFormChanged"></textarea>
          </div>
          <div v-if="activeDesignationTab === 'en'">
            <textarea v-model="property.designation_translate.en" class="form-control" rows="3" :placeholder="$t('PROPERTIES_COLLECTIONS.DESIGNATION')" @change="onFormChanged"></textarea>
          </div>

          <!--<textarea
            v-model="property.designation"
            :placeholder="$t('PROPERTIES_COLLECTIONS.DESIGNATION')"
            class="form-control"
            rows="3"
            @change="onFormChanged"
          ></textarea>-->
        </base-input>
        <validation-error :errors="apiValidationErrors.designation" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.TYPE')} (*)`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.TYPE')"
        >
          <el-select
            :clearable="true"
            class="select-primary pagination-select"
            :placeholder="$t('PROPERTIES_COLLECTIONS.TYPE')"
            v-model="property.property_type"
            @change="onFormChanged"
          >
            <el-option
              class="select-primary"
              v-for="(item, key) in PROPERTY_TYPES"
              :key="key"
              :label="$t(`PROPERTIES.PROPERTIES_TYPE_${item}`)"
              :value="item"
            >
            </el-option>
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.property_type" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.REGISTRATION_NUMBER')} (*)`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.REGISTRATION_NUMBER')"
          v-model="property.registration_number"
          @change="onFormChanged"
        />
        <validation-error :errors="apiValidationErrors.registration_number" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('COMMON.STATUS')} (*)`"
          :placeholder="$t('COMMON.STATUS')"
        >
          <el-select
            :clearable="true"
            class="select-primary pagination-select"
            v-model="property.status"
            @change="
              (value) => {
                if (value !== STATUS_PAIED) {
                  property.cancel_reason = null;
                }
                onFormChanged();
              }
            "
            :placeholder="$t('COMMON.STATUS')"
          >
            <template v-for="(item, key) in PROPERTY_STATUS">
              <el-option
                v-if="limitedStatus.includes(item)"
                class="select-primary"
                :key="key"
                :label="$t(`PROPERTIES_COLLECTIONS.PROPERTIES_STATUS_${item}`)"
                :value="item"
              >
              </el-option>
            </template>
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.status" />
      </div>
      
      <div class="form-wrapper full" v-if="property.status === STATUS_PAIED">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.CANCEL_REASON')} (*)`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.CANCEL_REASON')"
        >
          <textarea
            v-model="property.cancel_reason"
            :placeholder="$t('PROPERTIES_COLLECTIONS.CANCEL_REASON')"
            class="form-control"
            rows="3"
            @change="onFormChanged"
          ></textarea>
        </base-input>
        <validation-error :errors="apiValidationErrors.cancel_reason" />
      </div>

      <div
        class="form-wrapper"
        v-if="$currentUserCan($permissions.PERM_ACCESS_ALL_FIELDS_PROPERTIES)"
      >
        <base-input
          :label="`${$t('COMMON.MRC_FEES')}`"
          :placeholder="$t('COMMON.MRC_FEES')"
          :disabled="property.is_mrc_fees_automatic"
          v-model="property.mrc_fees"
          @change="onFormChanged"
        />
        <validation-error :errors="apiValidationErrors.mrc_fees" />
      </div>

      <div class="form-wrapper full">
        <batch-numbers-inputs
          :label="`${$t('PROPERTIES_COLLECTIONS.BATCH_NUMBER')} (*)`"
          :batchNumbers="property.batch_numbers"
          @batchNumbersChanged="
            (batchNumbers) => {
              property.batch_numbers = batchNumbers;
              onFormChanged();
            }
          "
        />
        <validation-error :errors="apiValidationErrors.batch_numbers" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.REGISTRATION_DIVISION')}`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.REGISTRATION_DIVISION')"
        >
          <el-select
            :clearable="true"
            filterable
            class="select-primary pagination-select"
            :placeholder="$t('PROPERTIES_COLLECTIONS.REGISTRATION_DIVISION')"
            v-model="property.registrationDivision.id"
            @change="onFormChanged"
          >
            <el-option
              class="select-primary"
              v-for="(item, key) in registrationDivisions"
              :key="key"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </base-input>
        <validation-error :errors="apiValidationErrors.registrationDivision" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.ORIGIN')}`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.ORIGIN')"
        >
          <el-select
            :clearable="true"
            class="select-primary pagination-select"
            :placeholder="$t('PROPERTIES_COLLECTIONS.ORIGIN')"
            v-model="property.origin"
            @change="onFormChanged"
          >
            <el-option
              class="select-primary"
              v-for="(item, key) in PROPERTY_ORIGINS"
              :key="key"
              :label="$t(`PROPERTIES.PROPERTIES_ORIGIN_${item}`)"
              :value="item"
            >
            </el-option>
          </el-select>
        </base-input>
        <validation-error
          :errors="apiValidationErrors.origin"
        />
      </div>

      <div class="form-wrapper full">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.REFERENCE_CSS')}`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.REFERENCE_CSS')"
          v-model="property.reference_css"
          @change="onFormChanged"
        />
        <validation-error
          :errors="apiValidationErrors.reference_css"
        />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES.ACQUISITION_NUMBER')}`"
          :placeholder="$t('PROPERTIES.ACQUISITION_NUMBER')"
          v-model="property.acquisition_number"
          @change="onFormChanged"
        />
        <validation-error :errors="apiValidationErrors.acquisition_number" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.ACQUISITION_METHODE')}`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.ACQUISITION_METHODE')"
          v-model="property.acquisition_method"
          @change="onFormChanged"
        />
        <validation-error :errors="apiValidationErrors.acquisition_method" />
      </div>

      <div
        class="form-wrapper full"
        v-if="$currentUserCan($permissions.PERM_ACCESS_ALL_FIELDS_PROPERTIES)"
      >
        <base-input
          :label="`${$t('PROPERTIES_COLLECTIONS.PROPERTY_NUMBER')}`"
          :placeholder="$t('PROPERTIES_COLLECTIONS.PROPERTY_NUMBER')"
          v-model="property.property_number"
          @change="onFormChanged"
        />
        <validation-error :errors="apiValidationErrors.property_number" />
      </div>

      <div class="form-wrapper full">
        <addresses-selector
          @addressInputChangeChanged="
            (values) => {
              property = {
                ...property,
                ...values,
              };
              onFormChanged();
            }
          "
        />
      </div>

      <div class="form-wrapper full">
        <base-input
          :label="`${$t('COMMON.ADDRESS')} (*)`"
          inputClasses="text-uppercase"
          style="text-transform: uppercase"
          v-model="property.address"
          @change="
            () => {
              onFormChanged();
            }
          "
        />
        <validation-error :errors="apiValidationErrors.address" />
      </div>

      <div class="form-wrapper">
        <base-input
          inputClasses="text-uppercase"
          :label="`${$t('COMMON.CITY')} (*)`"
          v-model="property.city"
          @change="
            () => {
              onFormChanged();
            }
          "
        />
        <validation-error :errors="apiValidationErrors.city" />
      </div>

      <div class="form-wrapper">
        <base-input
          inputClasses="text-uppercase"
          :label="`${$t('COMMON.ZIPCODE')}`"
          v-model="property.zipcode"
          @change="
            () => {
              onFormChanged();
            }
          "
        />
        <validation-error :errors="apiValidationErrors.zipcode" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('COMMON.STATE')} (*)`"
          :placeholder="$t('COMMON.STATE')"
        >
          <state-selector
            inputClasses="text-uppercase"
            :country="property.country"
            :state="property.state"
            :filterable="true"
            :showAll="false"
            @stateChanged="
              (state) => {
                property.state = state;
                onFormChanged();
              }
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.state" />
      </div>

      <div class="form-wrapper">
        <base-input
          :label="`${$t('COMMON.COUNTRY')} (*)`"
          :placeholder="$t('COMMON.COUNTRY')"
        >
          <country-selector
            inputClasses="text-uppercase"
            :country="property.country"
            :filterable="true"
            :showAll="false"
            @countryChanged="
              (country) => {
                property.country = country;
                onFormChanged();
              }
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.country" />
      </div>

      <!-- Other infos links -->
      <div class="form-wrapper full">
        <base-input :label="`${$t('PROPERTIES_COLLECTIONS.INFOS_LINKS')}`">
          <infos-links-selector
            :infosLinks="property.infos_links"
            @infosLinksChanged="
              (infosLinks) => {
                property.infos_links = infosLinks;
                onFormChanged();
              }
            "
          />
        </base-input>
        <validation-error :errors="apiValidationErrors.other_phones" />
      </div>

      <div class="form-wrapper full">
        <!-- Excerpt -->
        <base-input
          :label="`${$t('COMMON.NOTE')}`"
          :placeholder="$t('COMMON.NOTE')"
        >
          <html-editor v-model="property.excerpt" @change="onFormChanged()">
          </html-editor>
        </base-input>
        <validation-error :errors="apiValidationErrors.excerpt" />
      </div>

      <div class="submit-wrapper">
        <base-button
          type="button"
          class="btn btn-sm elite-submit"
          native-type="submit"
          :disabled="loading"
        >
          <i class="fas fa-spinner fa-spin" v-if="loading" />
          {{
            property.id
              ? $t("PROPERTIES.EDIT_PROPERTY")
              : $t("PROPERTIES.ADD_PROPERTY")
          }}
        </base-button>
      </div>
    </form>

    <modal :show="showModal" modal-classes="modal-secondary" size="sm">
      <div class="" slot="header">
        <h2 id="">
          {{ $t("COMMON.CONFIRMATION") }}
        </h2>
      </div>
      <div class="">
        <div class="text-center mt--4">
          {{ $t("PROPERTIES.CHANGE_READY_STATUS") }}
        </div>
        <div class="text-center">
          <strong class="text-lowercase">
            {{
              $t("PROPERTIES.CONFIRMATION_QUESTION", {
                status: $t(`PROPERTIES_COLLECTIONS.PROPERTIES_STATUS_${property.status}`),
              })
            }}
          </strong>
        </div>
      </div>
      <template slot="footer">
        <button
          type="submit"
          class="btn btn-primary"
          @click="continueFormSubmitProcess"
          :disabled="loading"
        >
          <span v-if="loading" class="btn-inner--icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          {{ $t("COMMON.CONTINUE") }}
        </button>

        <button
          type="button"
          class="btn btn-link ml-auto"
          @click="toggleModalState"
          :disabled="loading"
        >
          {{ $t("COMMON.CANCEL") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
import { Option, Select } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import ValidationError from "@/components/ValidationError.vue";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import LocationsSelector from "@/components/LocationsSelector.vue";
import ContactsSelector from "@/components/ContactsSelector.vue";
import TaxesSelector from "@/components/TaxesSelector.vue";
import BatchNumbersInputs from "@/components/BatchNumbersInputs.vue";
import CountrySelector from "@/components/CountrySelector.vue";
import StateSelector from "@/components/StateSelector.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  PROPERTY_STATUS,
  PROPERTY_TAXES,
  PROPERTY_TYPES,
  PROPERTY_ORIGINS,
  STATUS_WAITING_PAYMENT,
  STATUS_PARTIAL_PAYMENT,
  STATUS_PAIED,
  STATUS_APPROVED,
} from "@/constants/propertiesCollection";
import AddressesSelector from "@/components/AddressesSelector.vue";
import InfosLinksSelector from "@/components/InfosLinksSelector.vue";
import ContactForm from "../../../CrmModule/ContactManagement/partials/ContactForm.vue";
import defaultContact from "../../../CrmModule/ContactManagement/defaultContact";

export default {
  layout: "DashboardLayout",

  components: {
    CountrySelector,
    flatPicker,
    StateSelector,
    BaseInput,
    ValidationError,
    OrganizationSelector,
    HtmlEditor,
    LocationsSelector,
    ContactsSelector,
    TaxesSelector,
    BatchNumbersInputs,
    AddressesSelector,
    [Select.name]: Select,
    [Option.name]: Option,
    InfosLinksSelector,
    ContactForm,
  },

  mixins: [formMixin],

  props: ["propertyData", "formErrors", "loading"],

  data() {
    let propertyData = { ...this.propertyData };
    propertyData = this.$fillUserOrganizationData(propertyData);
    return {
      property: propertyData,
      oldStatus: this.propertyData?.status,
      PROPERTY_STATUS,
      PROPERTY_TYPES,
      PROPERTY_ORIGINS,
      PROPERTY_TAXES,
      STATUS_PAIED,
      showModal: false,
      registrationDivisions: [],
      limitedStatus: this.$currentUserCan(
        this.$permissions.PERM_CHANGE_CONFIRMED_STATUS_PROPERTIES
      )
        ? PROPERTY_STATUS
        : [STATUS_WAITING_PAYMENT, STATUS_PARTIAL_PAYMENT, STATUS_PAIED, STATUS_APPROVED],

      activeDesignationTab: 'fr',
      showAwarderFormModal: false,
      contact: cloneDeep(defaultContact),
      awarder: cloneDeep(defaultContact),
      contactsSelectorKey: 0,
    };
  },

  created() {
    if(this.property.designation_translate == null || this.label.designation_translate.length == 0){
      this.property.designation_translate = {
          fr: '',
          en: '',
        }
    }
    
    if(this.property.infos_links == null || this.property.infos_links == 0){
      this.property.infos_links = [];
    }
  },

  mounted() {
    this.getRegistrationDivisions();
  },

  computed: {
    /*soldAtLocal: {
      get() {
        return this.property.sold_at
          ? this.property.sold_at.replace("T", " ").replace(".000000Z", "")
          : "";
      },
      set(value) {
        this.property.sold_at = value ? value.replace(" ", "T") + ".000000Z" : null;
      }
    }*/
  },

  methods: {
    openAddAwarder(){
      this.showAwarderFormModal = true;
    },
    closeAddAwarder(){
      this.showAwarderFormModal = false;
    },
    async handleAwarderSubmit(contact) {
      
      let contactData = cloneDeep(contact);
      contactData.organization.id = this.property.organization.id;
      try {
        await this.$store.dispatch("contacts/add", contactData);
        const contact = await this.$store.getters["contacts/contact"];
        this.property.awarders.push({id : contact.id, type: 'contacts'});
        this.contactsSelectorKey += 1;
        this.showAwarderFormModal = false;
      } catch (error) {
        console.log(error);
        this.showAwarderFormModal = false;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
      }
    },
    async continueFormSubmitProcess() {
      this.toggleModalState();
      await this.submitInformation();
    },

    async getRegistrationDivisions() {
      await this.$store.dispatch("properties/registrationDivisions");
      this.registrationDivisions = this.$store.getters["properties/registrationDivisions"];
    },

    toggleModalState() {
      this.showModal = !this.showModal;
    },

    convertToISOString(date) {
      // Convertir la date en objet Date
      const dateObj = new Date(date);

      // Ajouter l'heure et la timezone
      const isoString = new Date(
        Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 23, 0, 0)
      ).toISOString();

      return isoString;
    },

    async submitInformation() {
      if (this.property.address) {
        this.property.address = this.property.address.toString().toUpperCase();
      }
      if (this.property.state) {
        this.property.state = this.property.state.toString();
      }
      if (!this.property?.auction?.id) {
        delete this.property.auction;
      }
      if (this.property.zipcode) {
        this.property.zipcode = this.property.zipcode.toString().toUpperCase();
      }
      
      const batch_numbers = this.property.batch_numbers.map((batch) => {
        return {
          value: parseInt(batch?.value?.toString().replaceAll(" ", ""), 10),
        };
      });
      //this.property.sold_at = this.$convertDateToUtc(this.property.sold_at);
      //this.property.sold_at = this.convertToISOString(this.property.sold_at);
      let propertyData = cloneDeep({ ...this.property, batch_numbers });
      propertyData = this.$fillUserOrganizationData(propertyData);
      this.$emit("propertySubmitted", propertyData);
    },

    onFormChanged() {
      this.$emit("formChanged");
    },
    async handleSubmit() {
      if (
        this.oldStatus === STATUS_APPROVED &&
        (this.property.status === STATUS_WAITING_PAYMENT ||
          this.property.status === STATUS_PARTIAL_PAYMENT ||
          this.property.status === STATUS_PAIED)
      ) {
        console.log('fffff');
        this.toggleModalState();
        return 0;
      } else {
        await this.submitInformation();
      }
    },
  },

  watch: {
    formErrors(errors) {
      if (errors) {
        this.setApiValidation(errors);
      }
    },
    propertyData(propertyData) {
      if (propertyData) {
        this.oldStatus = propertyData?.status;
        this.property = {
          ...this.property,
          ...cloneDeep(propertyData),
        };
      }
    },
  },
};
</script>
<style lang="scss">
  .add-form .form-control[type="text"]:disabled {
  cursor: not-allowed;
  background-color: #e9ecef;
}
.tabs-lang {
  display: flex;
  list-style-type: none;
  padding: 0;
}
.tabs-lang li {
  padding: 10px;
  cursor: pointer;
}
.tabs-lang li.active {
  font-weight: bold;
}
.form-group {
  &.properties-selector {
    > label {
      display: block;
      font-size: 16px;
      margin-bottom: 10px;
    }

    .form-group-item {
      flex: 1;
      padding: 0 10px;
      .el-select {
        margin-top: 8px;
      }
      &.remove {
        max-width: 53px;
      }
    }

    .remove-properties-button {
      padding-left: 10px;
      button {
        box-shadow: none;
        border: none;
        margin: 0;
        &.btn-danger {
          width: 43px;
          height: 43px;
          border-radius: 8px;
          background-color: #f5365c;
          margin-bottom: 0;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          i {
            font-size: 20px;
            color: #fff;
          }
        }
      }
    }

    button {
      &.add {
        width: 43px;
        height: 43px;
        border-radius: 8px;
        background-color: #000;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 15px 0 0 0;
        i {
          font-size: 18px;
          color: #fff;
        }
      }
    }
  }

  .properties-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin: 10px 0 0 0;

    .form-group-item {
      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    &:first-child {
      margin-top: 15px;
    }

    .form-group {
      margin-bottom: 0;
    }
  }
}
.modal-award-header{
  padding-right: 0px !important;
  padding-top: 0px !important;
}
</style>

